import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import SEO from '@/components/SEO';
import { Card } from '@/components/ui/card';
import { Shield } from 'lucide-react';

export const Datenschutz = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <SEO
        title="Datenschutzerklärung – RetailInvest"
        description="Datenschutzerklärung gem. Art. 13, 14 DSGVO für RetailInvest by Heinrichs Immobilien"
        url="/datenschutz"
      />
      <Navbar />
      <main className="flex-grow bg-gray-50 py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Header */}
          <div className="mb-8">
            <div className="w-16 h-1 bg-gradient-to-r from-[#D4A853] to-[#F0C870] mb-4"></div>
            <h1 className="text-4xl md:text-5xl font-bold mb-4" style={{ color: 'var(--navy-900)' }}>
              Datenschutzerklärung
            </h1>
            <p className="text-lg" style={{ color: 'var(--gray-600)' }}>
              Informationen gem. Art. 13, 14 DSGVO
            </p>
          </div>

          {/* Intro */}
          <Card className="glass-card p-8 mb-8">
            <div className="flex items-start gap-4">
              <Shield className="h-8 w-8 flex-shrink-0" style={{ color: 'var(--gold-600)' }} />
              <div>
                <h2 className="text-2xl font-bold mb-3" style={{ color: 'var(--navy-800)' }}>
                  Ihre Privatsphäre ist uns wichtig
                </h2>
                <p style={{ color: 'var(--gray-700)' }}>
                  Der Schutz Ihrer personenbezogenen Daten ist uns ein wichtiges Anliegen. 
                  Nachfolgend informieren wir Sie über den Umgang mit Ihren Daten bei der 
                  Nutzung unserer Website.
                </p>
              </div>
            </div>
          </Card>

          {/* Content */}
          <Card className="glass-card p-8 mb-8">
            <div className="prose prose-sm max-w-none" style={{ color: 'var(--gray-700)' }}>
              
              {/* 1. Datenschutz auf einen Blick */}
              <h2 className="text-2xl font-bold mb-4 mt-8" style={{ color: 'var(--navy-800)' }}>
                1. Datenschutz auf einen Blick
              </h2>
              
              <h3 className="text-xl font-semibold mb-3 mt-6" style={{ color: 'var(--navy-700)' }}>
                Allgemeine Hinweise
              </h3>
              <p className="mb-4">
                Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können. Ausführliche Informationen zum Thema Datenschutz entnehmen Sie unserer unter diesem Text aufgeführten Datenschutzerklärung.
              </p>

              <h3 className="text-xl font-semibold mb-3 mt-6" style={{ color: 'var(--navy-700)' }}>
                Datenerfassung auf dieser Website
              </h3>
              
              <h4 className="text-lg font-semibold mb-2 mt-4" style={{ color: 'var(--navy-700)' }}>
                Wer ist verantwortlich für die Datenerfassung auf dieser Website?
              </h4>
              <p className="mb-4">
                Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten können Sie dem Abschnitt „Hinweis zur Verantwortlichen Stelle" in dieser Datenschutzerklärung entnehmen.
              </p>

              <h4 className="text-lg font-semibold mb-2 mt-4" style={{ color: 'var(--navy-700)' }}>
                Wie erfassen wir Ihre Daten?
              </h4>
              <p className="mb-4">
                Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich z. B. um Daten handeln, die Sie in ein Kontaktformular eingeben.
              </p>
              <p className="mb-4">
                Andere Daten werden automatisch oder nach Ihrer Einwilligung beim Besuch der Website durch unsere IT-Systeme erfasst. Das sind vor allem technische Daten (z. B. Internetbrowser, Betriebssystem oder Uhrzeit des Seitenaufrufs). Die Erfassung dieser Daten erfolgt automatisch, sobald Sie diese Website betreten.
              </p>

              <h4 className="text-lg font-semibold mb-2 mt-4" style={{ color: 'var(--navy-700)' }}>
                Wofür nutzen wir Ihre Daten?
              </h4>
              <p className="mb-4">
                Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website zu gewährleisten. Andere Daten können zur Analyse Ihres Nutzerverhaltens verwendet werden. Sofern über die Website Verträge geschlossen oder angebahnt werden können, werden die übermittelten Daten auch für Vertragsangebote, Bestellungen oder sonstige Auftragsanfragen verarbeitet.
              </p>

              <h4 className="text-lg font-semibold mb-2 mt-4" style={{ color: 'var(--navy-700)' }}>
                Welche Rechte haben Sie bezüglich Ihrer Daten?
              </h4>
              <p className="mb-4">
                Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft, Empfänger und Zweck Ihrer gespeicherten personenbezogenen Daten zu erhalten. Sie haben außerdem ein Recht, die Berichtigung oder Löschung dieser Daten zu verlangen. Wenn Sie eine Einwilligung zur Datenverarbeitung erteilt haben, können Sie diese Einwilligung jederzeit für die Zukunft widerrufen. Außerdem haben Sie das Recht, unter bestimmten Umständen die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen. Des Weiteren steht Ihnen ein Beschwerderecht bei der zuständigen Aufsichtsbehörde zu.
              </p>
              <p className="mb-4">
                Hierzu sowie zu weiteren Fragen zum Thema Datenschutz können Sie sich jederzeit an uns wenden.
              </p>

              {/* 2. Hosting und CDN */}
              <h2 className="text-2xl font-bold mb-4 mt-8" style={{ color: 'var(--navy-800)' }}>
                2. Hosting und Content Delivery Networks (CDN)
              </h2>
              
              <p className="mb-4">
                Wir hosten die Inhalte unserer Website bei folgendem Anbieter:
              </p>

              <h3 className="text-xl font-semibold mb-3 mt-6" style={{ color: 'var(--navy-700)' }}>
                DomainFactory
              </h3>
              <p className="mb-4">
                Anbieter ist die DomainFactory GmbH, c/o WeWork, Neuturmstraße 5, 80331 München (nachfolgend DomainFactory). Wenn Sie unsere Website besuchen, erfasst DomainFactory verschiedene Logfiles inklusive Ihrer IP-Adressen.
              </p>
              <p className="mb-4">
                Details entnehmen Sie der Datenschutzerklärung von DomainFactory: <a href="https://www.df.eu/de/datenschutz/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">https://www.df.eu/de/datenschutz/</a>
              </p>
              <p className="mb-4">
                Die Verwendung von DomainFactory erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Wir haben ein berechtigtes Interesse an einer möglichst zuverlässigen Darstellung unserer Website. Sofern eine entsprechende Einwilligung abgefragt wurde, erfolgt die Verarbeitung ausschließlich auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO und § 25 Abs. 1 TDDDG, soweit die Einwilligung die Speicherung von Cookies oder den Zugriff auf Informationen im Endgerät des Nutzers (z. B. für Device-Fingerprinting) im Sinne des TDDDG umfasst. Die Einwilligung ist jederzeit widerrufbar.
              </p>

              <h4 className="text-lg font-semibold mb-2 mt-4" style={{ color: 'var(--navy-700)' }}>
                Auftragsverarbeitung
              </h4>
              <p className="mb-4">
                Wir haben einen Vertrag über Auftragsverarbeitung (AVV) zur Nutzung des oben genannten Dienstes geschlossen. Hierbei handelt es sich um einen datenschutzrechtlich vorgeschriebenen Vertrag, der gewährleistet, dass dieser die personenbezogenen Daten unserer Websitebesucher nur nach unseren Weisungen und unter Einhaltung der DSGVO verarbeitet.
              </p>

              {/* 3. Allgemeine Hinweise und Pflichtinformationen */}
              <h2 className="text-2xl font-bold mb-4 mt-8" style={{ color: 'var(--navy-800)' }}>
                3. Allgemeine Hinweise und Pflichtinformationen
              </h2>

              <h3 className="text-xl font-semibold mb-3 mt-6" style={{ color: 'var(--navy-700)' }}>
                Datenschutz
              </h3>
              <p className="mb-4">
                Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend den gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.
              </p>
              <p className="mb-4">
                Wenn Sie diese Website benutzen, werden verschiedene personenbezogene Daten erhoben. Personenbezogene Daten sind Daten, mit denen Sie persönlich identifiziert werden können. Die vorliegende Datenschutzerklärung erläutert, welche Daten wir erheben und wofür wir sie nutzen. Sie erläutert auch, wie und zu welchem Zweck das geschieht.
              </p>
              <p className="mb-4">
                Wir weisen darauf hin, dass die Datenübertragung im Internet (z. B. bei der Kommunikation per E-Mail) Sicherheitslücken aufweisen kann. Ein lückenloser Schutz der Daten vor dem Zugriff durch Dritte ist nicht möglich.
              </p>

              <h3 className="text-xl font-semibold mb-3 mt-6" style={{ color: 'var(--navy-700)' }}>
                Hinweis zur verantwortlichen Stelle
              </h3>
              <p className="mb-4">
                Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:
              </p>
              <p className="mb-2">
                <strong>Heinrichs Immobilien</strong><br />
                Andreas Heinrichs<br />
                Rindermarkt 8, 85354 Freising
              </p>
              <p className="mb-4">
                Telefon: 08161 1851360<br />
                E-Mail: info@heinrichsimmobilien.de
              </p>
              <p className="mb-4">
                Verantwortliche Stelle ist die natürliche oder juristische Person, die allein oder gemeinsam mit anderen über die Zwecke und Mittel der Verarbeitung von personenbezogenen Daten (z. B. Namen, E-Mail-Adressen o. Ä.) entscheidet.
              </p>

              <h3 className="text-xl font-semibold mb-3 mt-6" style={{ color: 'var(--navy-700)' }}>
                Speicherdauer
              </h3>
              <p className="mb-4">
                Soweit innerhalb dieser Datenschutzerklärung keine speziellere Speicherdauer genannt wurde, verbleiben Ihre personenbezogenen Daten bei uns, bis der Zweck für die Datenverarbeitung entfällt. Wenn Sie ein berechtigtes Löschersuchen geltend machen oder eine Einwilligung zur Datenverarbeitung widerrufen, werden Ihre Daten gelöscht, sofern wir keine anderen rechtlich zulässigen Gründe für die Speicherung Ihrer personenbezogenen Daten haben (z. B. steuer- oder handelsrechtliche Aufbewahrungsfristen); im letztgenannten Fall erfolgt die Löschung nach Fortfall dieser Gründe.
              </p>

              <h3 className="text-xl font-semibold mb-3 mt-6" style={{ color: 'var(--navy-700)' }}>
                Widerruf Ihrer Einwilligung zur Datenverarbeitung
              </h3>
              <p className="mb-4">
                Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen Einwilligung möglich. Sie können eine bereits erteilte Einwilligung jederzeit widerrufen. Die Rechtmäßigkeit der bis zum Widerruf erfolgten Datenverarbeitung bleibt vom Widerruf unberührt.
              </p>

              <h3 className="text-xl font-semibold mb-3 mt-6" style={{ color: 'var(--navy-700)' }}>
                SSL- bzw. TLS-Verschlüsselung
              </h3>
              <p className="mb-4">
                Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher Inhalte, wie zum Beispiel Bestellungen oder Anfragen, die Sie an uns als Seitenbetreiber senden, eine SSL- bzw. TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie daran, dass die Adresszeile des Browsers von „http://" auf „https://" wechselt und an dem Schloss-Symbol in Ihrer Browserzeile.
              </p>
              <p className="mb-4">
                Wenn die SSL- bzw. TLS-Verschlüsselung aktiviert ist, können die Daten, die Sie an uns übermitteln, nicht von Dritten mitgelesen werden.
              </p>

              {/* 4. Datenerfassung auf dieser Website */}
              <h2 className="text-2xl font-bold mb-4 mt-8" style={{ color: 'var(--navy-800)' }}>
                4. Datenerfassung auf dieser Website
              </h2>

              <h3 className="text-xl font-semibold mb-3 mt-6" style={{ color: 'var(--navy-700)' }}>
                Cookies
              </h3>
              <p className="mb-4">
                Unsere Internetseiten verwenden so genannte „Cookies". Cookies sind kleine Datenpakete und richten auf Ihrem Endgerät keinen Schaden an. Sie werden entweder vorübergehend für die Dauer einer Sitzung (Session-Cookies) oder dauerhaft (permanente Cookies) auf Ihrem Endgerät gespeichert. Session-Cookies werden nach Ende Ihres Besuchs automatisch gelöscht. Permanente Cookies bleiben auf Ihrem Endgerät gespeichert, bis Sie diese selbst löschen oder eine automatische Löschung durch Ihren Webbrowser erfolgt.
              </p>
              <p className="mb-4">
                Cookies können von uns (First-Party-Cookies) oder von Drittunternehmen stammen (sog. Third-Party-Cookies). Third-Party-Cookies ermöglichen die Einbindung bestimmter Dienstleistungen von Drittunternehmen innerhalb von Webseiten (z. B. Cookies zur Abwicklung von Zahlungsdienstleistungen).
              </p>

              <h3 className="text-xl font-semibold mb-3 mt-6" style={{ color: 'var(--navy-700)' }}>
                Anfrage per E-Mail, Telefon oder Telefax
              </h3>
              <p className="mb-4">
                Wenn Sie uns per E-Mail, Telefon oder Telefax kontaktieren, wird Ihre Anfrage inklusive aller daraus hervorgehenden personenbezogenen Daten (Name, Anfrage) zum Zwecke der Bearbeitung Ihres Anliegens bei uns gespeichert und verarbeitet. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
              </p>
              <p className="mb-4">
                Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO, sofern Ihre Anfrage mit der Erfüllung eines Vertrags zusammenhängt oder zur Durchführung vorvertraglicher Maßnahmen erforderlich ist. In allen übrigen Fällen beruht die Verarbeitung auf unserem berechtigten Interesse an der effektiven Bearbeitung der an uns gerichteten Anfragen (Art. 6 Abs. 1 lit. f DSGVO) oder auf Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO) sofern diese abgefragt wurde; die Einwilligung ist jederzeit widerrufbar.
              </p>

              {/* Kontakt für Datenschutzfragen */}
              <div className="mt-12 p-6 bg-blue-50 rounded-lg border border-blue-200">
                <h3 className="text-xl font-semibold mb-3" style={{ color: 'var(--navy-700)' }}>
                  Fragen zum Datenschutz?
                </h3>
                <p className="mb-2" style={{ color: 'var(--gray-700)' }}>
                  Bei Fragen zur Erhebung, Verarbeitung oder Nutzung Ihrer personenbezogenen Daten, bei Auskünften, Berichtigung, Einschränkung oder Löschung von Daten sowie Widerruf erteilter Einwilligungen wenden Sie sich bitte an:
                </p>
                <p style={{ color: 'var(--gray-700)' }}>
                  <strong>Andreas Heinrichs</strong><br />
                  E-Mail: info@heinrichsimmobilien.de<br />
                  Telefon: 08161 1851360
                </p>
              </div>

              <p className="mt-8 text-sm" style={{ color: 'var(--gray-600)' }}>
                Stand: Januar 2025
              </p>
            </div>
          </Card>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Datenschutz;
